export default __webpack_public_path__ + "static/153-5752413ad17d2b056bd5700fec032640.jpg";